module.exports = __webpack_public_path__ + "img/galicia-off.e5426fc7.png";